import { Injectable } from '@angular/core';
import { CookieService } from 'ngx-cookie-service';
import { NgxSpinnerService } from 'ngx-spinner';
import { AppointmentService } from '../business-services/appointment.service';
import * as Enums from '../../../../Autofacets-Core/src/app/utils/enums';
import { AppointmentDetail } from '../business-entities/appointmentDetail-model';
import { DatePipe } from '@angular/common';
import { AppointmentWorkOrderService } from '../business-services/appointment-work-order.service';
import { Features } from '../business-entities/user-role-view-model';
import { AppointmentList, GenericRentalCar, RentalCar } from '../business-entities/appointmentList-model';
import { EditAppointmentService } from '../business-services/edit-appointment.service';
import { Utility } from 'projects/Autofacets-Core/src/app/utils/utility';
import { BrandViewModel } from '../business-entities/brand-view-model';
import { AppointmentStatus, DocumentPartStatus } from '../business-entities/appointmentStatus-model';
import { ModalDismissReasons, NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { DealerWorkingHoursBusinessService } from './dealer-working-hours.service';
import { DealerOpeningHoursViewModel } from '../business-entities/dealer-opening-hours-view-model';
import { DealerDetails } from '../business-entities/dealer-details.model';
import { Constant } from 'projects/Autofacets-Core/src/app/utils/constant';
import { DealerViewModel } from '../business-entities/dealer-view-model';
import { TranslateService } from '@ngx-translate/core';
import { ToastrService } from 'ngx-toastr';
import * as CommonEnums from 'projects/Autofacets-Core/src/app/utils/enums';
import { ClipboardService } from 'ngx-clipboard';
import { Comments } from 'projects/Administration/src/app/business-entities/dwo-comments.model';
import { UserDataService } from 'src/app/DataServices/user-data.service';
import { DwoDocumentsBusinessService } from './dwo-documents.service';
import { NgbdModalContent } from 'projects/Autofacets-Core/src/app/shared/delete-modal.component';
import { AppLinkService } from './app-link.service';
import { UserRequestModel } from '../business-entities/user-view-model';
import { ReceptionService } from './reception.service';

@Injectable({ providedIn: 'root' })
export class AppointmentCommonService {

  isRentalService: boolean = false;
  isRentalCar: boolean = false;
  genericRentalCar: boolean = false;
  RentalCarModel: any;
  RentalCarPrice: any;
  appointmentBookedDate: any;
  appointmentCreatedDate: any;
  appointmentUpdatedDate: any;
  appointmentPKKDate: any;
  StartDate;
  AppointmentHour: number;
  AppointmentMinutes: number;
  DateClass: string;
  IsDisableBookedDate: boolean = true;
  IsonHoldStatus: boolean = false;
  featureList: Features[] = [];
  appointmentStatusName: string;
  SelectedDocumentPartStatus: any = null;
  isShowGenerateTrackerButton: boolean = false;
  isShowGenerateAndSendCheckInButton: boolean = false;
  IsActive: boolean = true;
  FinishHour: number;
  DeliveryHour: number;
  DeliveryDate: string;
  StatusDisabled: boolean = false;
  isQuote: boolean = false;
  FinnishedDate: string;
  brandList: BrandViewModel[];
  previousStatus: any;
  dealerWorkingHours: DealerOpeningHoursViewModel[];
  documentPartStatus: DocumentPartStatus[];
  DefaultStartTime: string;
  DefaultEndTime: string;
  contactDetails: AppointmentDetail;
  dealers: DealerViewModel[] = [];
  shiftDealerId: string;
  rentalCarList: RentalCar[] = [];
  appointmentDetails: AppointmentList;
  statusList: AppointmentStatus[];
  availRentalCarList: RentalCar[] = [];
  genericRentalCarList: GenericRentalCar[] = [];
  isAppointmentShifted: boolean = false;
  SelectedSalesPerson: any = null;
  SelectedStatus: any = null;
  FinishMinutes: string;
  deliveryTimeSlot: any = { hour: 0, minute: 0 };
  finishTimeSlot: any = { hour: 0, minute: 0 };
  DeliveryMinutes: number;
  campaignService: boolean;
  isSaveAndClose: boolean = false;
  isPopupClose: boolean = false;
  internalComments: Comments[] = [];
  internalCommentsSelf: Comments[] = [];
  comments: Comments[];
  customerComments: Comments[] = [];
  mechanicComments: Comments[] = [];
  commentsLength: number;
  internalCommentData: string = null;
  internalComment: string;
  customerComment: string;
  mechanicComment:string;
  userId: string;
  commentType: number;
  closeResult: string;
  Addedcomments: any;
  commentId: any;
  closeModel: any;
  popupCloseResult = false;
  singlePhoneNo: any;
  nomineeMobileCode:any = null;
  mobileNo: any;
  mobileCode:any;
  selectedCampaignService:number = 1;
  serviceAdvisorList:any;
  userRequestModel: UserRequestModel = {
      roleId: 0,
      isAdvanceSearch: false,
      statusId: 0,
      dealerId: "",
      email:"",
      mobile:"",
      locationCode:""
  };

  constructor(
    private readonly appointmentService: AppointmentService,
    private readonly spinner: NgxSpinnerService,
    private readonly cookieservice: CookieService,
    private readonly datePipe: DatePipe,
    public workOrderService: AppointmentWorkOrderService,
    public editAppointmentService: EditAppointmentService,
    private readonly dealerWorkingHoursBusinessService: DealerWorkingHoursBusinessService,
    private readonly translate: TranslateService,
    private readonly toastr: ToastrService,
    private readonly clipboardApi: ClipboardService,
    private readonly modalService: NgbModal,
    private readonly userService: UserDataService,
    private readonly service: DwoDocumentsBusinessService,
    private readonly appLinkService: AppLinkService,
    private readonly receptionBusinessService: ReceptionService
  ) {
    this.userId = this.userService.currentUserValue?.id;
    this.userService.currentUser.subscribe((user) => {
      this.userId = user?.id;
    });
   }

  getDismissReason(reason: any): boolean {
    if (reason === ModalDismissReasons.ESC) {
      return false;
    } else if (reason === ModalDismissReasons.BACKDROP_CLICK) {
      return false;
    } else {
      return reason;
    }
  }

  async getStatusBrand(dealerId: string, appointmentId: number, languageCode: string) {
    this.appointmentService.getStatusBrand(dealerId, appointmentId, languageCode).then(res => {
      this.brandList = res.responseObject.brand;
      this.statusList = res.responseObject.statusModel;
      this.documentPartStatus = res.responseObject.documentParts;

      let appointmentDetail = {
        brandList: this.brandList,
        statusList: this.statusList,
        documentPartStatus: this.documentPartStatus
      }
      return appointmentDetail;
    })
  }

  isDigit(event): void {
    const isDigit = Utility.isDigit(event);
    if (!isDigit) {
      event.preventDefault();
    }
  }

  ConfirmShiftAppoitment(content) {
    this.modalService.open(content, { ariaLabelledBy: 'modal-basic-title' }).result.then((result) => {
    }, (reason) => {
    });
  }

  async GetAppointmentDetail(Id: number) {
    let language = this.cookieservice.get('userSelectedLanguage')
    await this.appointmentService.GetAppointmentDetail(Id, language).then(result => {
      if (result.responseCode === Enums.ErrorCodes.SuccessCode) {
        this.contactDetails = result.responseObject;
        if (this.contactDetails) {

          // Contact Mobile Number 
          this.singlePhoneNo = this.contactDetails.singlePhoneNo;
          this.nomineeMobileCode = this.contactDetails.nomineeMobileCode

          // Sell To Customer Mobile Number
          this.mobileNo = this.contactDetails.mobileNo
          this.mobileCode = this.contactDetails.mobileCode
          
          this.contactDetails.mileageUpdateDate = this.contactDetails.mileageUpdateDate ? Utility.GetFormattedDateTime(Utility.ConvertUTCDateToLocalDate(this.contactDetails.mileageUpdateDate)) : null
          this.contactDetails.campaignUpdateDate = this.contactDetails.campaignUpdateDate ? Utility.GetFormattedDateTime(Utility.ConvertUTCDateToLocalDate(this.contactDetails.campaignUpdateDate)) : null
          this.campaignService = this.contactDetails.campaignService;
          if (this.contactDetails?.isRentalCarSelected && this.isRentalService) {
            this.isRentalCar = true;
            if (this.genericRentalCar) {
              this.RentalCarModel = this.contactDetails.rentalCompanyMakeName;
              this.RentalCarPrice = this.contactDetails.priceForDisply;
            }
            else {
              this.RentalCarModel = this.contactDetails.rentalLicensePlate;
              this.RentalCarPrice = this.contactDetails.price;
            }
          }
        }
        this.appointmentBookedDate = this.contactDetails.bookedDateTime ? new Date(this.contactDetails.bookedDateTime + 'Z') : null;
        if (this.contactDetails.bookedDateTime) {
          this.StartDate = this.datePipe.transform(this.contactDetails.bookedDateTime, 'dd.MM.yyyy');
          if (this.appointmentBookedDate) {
            this.AppointmentHour = this.appointmentBookedDate.getHours()
            this.AppointmentMinutes = this.appointmentBookedDate.getMinutes()
          }
        }
        this.IsDisableBookedDate = this.contactDetails.workorderStatusId === Enums.WOStatus.Prepared ? false : true;
        this.IsonHoldStatus = this.contactDetails.workorderStatusId === Enums.WOStatus.OnHold ? true : false;
        this.appointmentCreatedDate = this.contactDetails.createdDateTime ? new Date(this.contactDetails.createdDateTime + 'Z') : null;
        this.appointmentUpdatedDate = this.contactDetails.updatedDateTime ? new Date(this.contactDetails.updatedDateTime + 'Z') : null;
        this.appointmentPKKDate = this.contactDetails.pkkDate ? this.datePipe.transform(this.contactDetails.pkkDate, 'dd.MM.yyyy') : null;
        if (this.contactDetails.pickUpDateTime) {
          this.contactDetails.pickUpDateTime = new Date(this.contactDetails.pickUpDateTime + 'Z');
        }
        if (this.contactDetails.dropOffDateTime)
          this.contactDetails.dropOffDateTime = new Date(this.contactDetails.dropOffDateTime + 'Z');
        if (this.contactDetails.finishedTime)
          this.contactDetails.finishedTime = new Date(this.contactDetails.finishedTime + 'Z');
        if (this.contactDetails.deliveryTime)
          this.contactDetails.deliveryTime = new Date(this.contactDetails.deliveryTime + 'Z');
        this.workOrderService.contactDetails = this.contactDetails;
        let rentalCar = this.featureList.filter(x => x.featureCode === Enums.FeatureCode.GRentalCar)[0]?.isActive;
        this.workOrderService.contactDetails.isGenericRentalCar = rentalCar;
        this.workOrderService.personnelTax = result.responseObject.personnelTax;
        this.workOrderService.materialTax = result.responseObject.materialTax;
        if (this.contactDetails) {

          if (!this.contactDetails.previousKilometer)
            this.contactDetails.previousKilometer = 0;
          if (!this.contactDetails.kilometer)
            this.contactDetails.kilometer = this.contactDetails.previousKilometer;
          this.appointmentStatusName = this.contactDetails.appointmentStatus;
          this.appointmentDetails.appointmentStatus = this.contactDetails.appointmentStatus;
          this.appointmentDetails.workOrderStatus = this.contactDetails.workorderStatus;
          this.appointmentDetails.appointmentStatusColor = this.contactDetails.appointmentStatusColor;
          this.appointmentDetails.workOrderStatusColor = this.contactDetails.workorderStatusColor;
          this.editAppointmentService.appointmentDetails.workOrderStatusId = this.contactDetails.workorderStatusId
          if (this.contactDetails.documentPartStatus) {
            this.appointmentDetails.documentPartStatus = this.contactDetails.documentPartStatus;
            this.editAppointmentService.appointmentDetails.documentPartStatus = this.contactDetails.documentPartStatus;
            this.SelectedDocumentPartStatus = this.contactDetails.documentPartStatus;
          }
        }
        if (
          (this.editAppointmentService.appointmentDetails.workOrderStatusId !== Enums.WOStatus.WorkRequest) &&
        (this.editAppointmentService.appointmentDetails.workOrderStatusId !== Enums.WOStatus.InvoicePaid) &&
        (this.editAppointmentService.appointmentDetails.workOrderStatusId !== Enums.WOStatus.Cancelled) &&
          (this.editAppointmentService.appointmentDetails.workOrderStatusId !== Enums.WOStatus.Closed) &&
          (this.editAppointmentService.appointmentDetails.workOrderStatusId !== Enums.WOStatus.OnHold) &&
          !this.editAppointmentService.appointmentDetails.isFromArchive)
      {
        this.isShowGenerateAndSendCheckInButton = true;
        if(this.editAppointmentService.appointmentDetails.workOrderStatusId !== Enums.WOStatus.Prepared || this.contactDetails?.isCheckInDoneByCustomer)
          {
            this.isShowGenerateTrackerButton = true;
          }
          else{
            this.isShowGenerateTrackerButton = false;
          }

      }
      else{
        this.isShowGenerateTrackerButton = false;
        this.isShowGenerateAndSendCheckInButton = false;
      }

        
        this.IsActive = false;
        setTimeout(_ => {
          this.IsActive = true;
        }, 100);
        if (this.contactDetails.finishedTime) {
          this.FinnishedDate = this.contactDetails.finishedTime ? Utility.GetFormattedDate(Utility.ConvertUTCDateToLocalDate(this.contactDetails.finishedTime)) : null;
          this.FinishHour = this.contactDetails.finishedTime.getHours()
          this.FinishMinutes = this.contactDetails.finishedTime.getMinutes();
          this.finishTimeSlot = { hour: this.FinishHour, minute: this.FinishMinutes }
        }
        if (this.contactDetails.deliveryTime) {
          this.DeliveryDate = this.contactDetails.deliveryTime ? Utility.GetFormattedDate(Utility.ConvertUTCDateToLocalDate(this.contactDetails.deliveryTime)) : null;
          this.DeliveryHour = this.contactDetails.deliveryTime.getHours()
          this.DeliveryMinutes = this.contactDetails.deliveryTime.getMinutes();
          this.deliveryTimeSlot = { hour: this.DeliveryHour, minute: this.DeliveryMinutes }
        }
      }
      else {
        this.spinner.hide();
      }
    });
    return this.contactDetails;
  }

  async GetDefaultShift() {
    await this.dealerWorkingHoursBusinessService.getDealerWorkingHoursDetails(this.editAppointmentService.appointmentDetails.dealerId, 1).then((response) => {
      this.dealerWorkingHours = response;
      let shift = this.dealerWorkingHours?.find(x => x.dayNumber == Enums.WeekDays.Monday);
      this.DefaultStartTime = Utility.ConvertUTCDateToLocalTime(shift?.openingTimeHrs);
      this.DefaultEndTime = Utility.ConvertUTCDateToLocalTime(shift?.closingTimeHrs);
    });
  }

  mapDealerListToDealers(array: DealerDetails[]) {
    let supperArray = [];
    if (array && array.length > 0) {
      array.forEach(element => {
        let single = Object();
        single.dealerId = element.dealerId
        single.name = element.dealerName
        supperArray.push(single);
      })
    }
    return supperArray;
  }

  async getUserDealers() {
    let LanguageCode = this.cookieservice.get('userSelectedLanguage');
    const viewModel = { CustomerLatitude: 0, CustomerLongitude: 0, VehicleBrand: this.editAppointmentService.appointmentDetails?.brandCode, Language: LanguageCode };
    await this.appointmentService.GetAllDealerDetails(viewModel)
      .then((result) => {
        if (result.responseObject && result.responseObject.errorCount === 0 &&
          result.responseCode === Constant.SuccessResponseCode) {
          let dealerDetails = result.responseObject.result as DealerDetails[];
          if (this.contactDetails?.isCustomerWaiting) {
            dealerDetails = dealerDetails.filter(x => x.customerWaitingLimit > 0);
          }
          if (dealerDetails?.length > 0) {
            let dealers = dealerDetails.filter(x => x.dealerId != this.appointmentDetails.dealerId);
            if (dealers?.length > 0) {
              this.dealers = this.mapDealerListToDealers(dealers);
            }
          }
        }
        this.spinner.hide();
      });
    return this.dealers;
  }

  public generateStatusTrackerLink(data) {
    let model = {
      AppointmentGuid: data.AppointmentGuid
    };
    this.appLinkService.AddTrackerLink(model)
      .then(
        _res => {
          this.appLinkService.GetTrackerLink(model.AppointmentGuid).then(x => {
            this.editAppointmentService.trackerURL = x;
          }, _error => { this.spinner.hide(); })

          let successMessage = this.translate.instant("lblTrackerLinkGenerated");
          this.toastr.success(successMessage);

        },
        err => {
          console.error('HTTP Error', err);
        }
      );
  }

  async UpdateNeedAttention() {
    const viewModel = this.workOrderService.MapToViewNeedAttentionModel(true, false);
    this.spinner.show();
    await this.appointmentService.UpdateNeedAttention(viewModel)
      .then((response) => {
        if (response.responseObject) {
          this.spinner.hide();
          let successMessage = this.translate.instant("lblNeedAttentionResolved");
          this.toastr.success(successMessage);
          this.contactDetails.needAttention = viewModel.IsNeedAttention;
        }
      });
    return this.contactDetails;
  }

  getRentalCar() {
    this.spinner.show();
    this.rentalCarList = [];
    this.availRentalCarList = [];
    const feature = this.featureList.find(x => x.featureCode === CommonEnums.FeatureCode.GRentalCar);
    if (feature) {
      this.genericRentalCar = feature.isActive;
    }
    if (!this.genericRentalCar) {
      this.appointmentService.GetDealerRentalCars(this.editAppointmentService.appointmentDetails.dealerId).then((result) => {
        if (result.responseObject && result.responseObject.errorCount === 0 &&
          result.responseCode === CommonEnums.ErrorCodes.SuccessCode) {
          this.rentalCarList = result.responseObject.result as RentalCar[];
          this.rentalCarList.forEach(carListElement => {
            let isDateFound = false;
            carListElement.notAvailableDates.forEach(element => {
              if (new Date(element).setHours(0, 0, 0, 0) === new Date(this.contactDetails.bookedDateTime).setHours(0, 0, 0, 0))
                isDateFound = true;
            });
            carListElement.notAvailable = isDateFound;
            this.availRentalCarList.push(carListElement);
          });
        }
      })
    }
    else {
      this.appointmentService.GetGenericRentalCars(this.cookieservice.get('userSelectedLanguage'))
        .then((result) => {
          if (result.responseObject &&
            result.responseCode === CommonEnums.ErrorCodes.SuccessCode) {
            this.genericRentalCarList = result.responseObject as GenericRentalCar[];
            if (this.contactDetails.typeId > 0) {
              this.genericRentalCarList = this.genericRentalCarList.filter((x) => x.typeId !== this.contactDetails.typeId)
            }
          }
          this.spinner.hide();
        })
    }
    this.spinner.hide();
  }

  copyWorkOrderNumber() {
    this.clipboardApi.copyFromContent(this.appointmentDetails.workOrderNo)
  }
  copyTextRegistrationNumber() {
    this.clipboardApi.copyFromContent(this.appointmentDetails.licensePlate)
  }
  copyTextVINNumber() {
    this.clipboardApi.copyFromContent(this.appointmentDetails.chassisNo)
  }
  resetSalesPersonList() {
    this.SelectedSalesPerson = null;
  }
  onSalesPersonChange() {
    if (this.SelectedSalesPerson != null || this.SelectedSalesPerson != undefined) {
      // Empty on Purpose
    }
  }
  copyTextDealer() {
    this.clipboardApi.copyFromContent(this.appointmentDetails.dealerName)
  }

  ViewRemark(viewContent) {
    this.modalService.open(viewContent, { ariaLabelledBy: 'modal-basic-title', size: 'md' }).result.then((result) => {
    }, (reason) => {
    });
  }

  onDocumentPartStatusChange() {
    this.appointmentDetails.documentPartStatus = this.SelectedDocumentPartStatus;
  }
  getComments(id) {
    this.spinner.show()
    this.internalComments = [];
    this.mechanicComments = [];
    this.customerComments = [];
    this.internalCommentsSelf = [];
    this.comments = [];
    this.commentsLength = 0;
    this.internalComment = '';
    this.customerComment = '';
    this.mechanicComment = '';
    this.service.getDwoComments(id).then((res) => {
      if (res.responseObject) {
        this.comments = res.responseObject
        if (this.comments?.length !== undefined) {
          this.comments.forEach(x => { if (x.updatedDate !== null) x.updatedDate = Utility.ConvertUTCDateToLocalDate(x.updatedDate) }
          )
          this.commentsLength = this.comments?.length;
          this.CommentsByCount(1);
          this.CommentsByCount(2);
          this.CommentsByCount(3);
          this.internalComments = this.comments.filter(x => x.isInternalComments == 1);
          if (this.internalComments && this.internalComments?.length > 0) {
            this.internalComment = this.internalComments[(this.internalComments.length - 1)].comment;
          }
          if(this.customerComments && this.customerComments?.length > 0){
            this.customerComment = this.customerComments[(this.customerComments.length - 1)].comment;
          }
          if(this.mechanicComments && this.mechanicComments?.length > 0){
            this.mechanicComment = this.mechanicComments[(this.mechanicComments.length - 1)].comment;
          }
          this.internalCommentsSelf = this.internalComments.filter(x => x.userId == this.userId);
        }
      }
    }).finally(() => {
      this.spinner.hide();
    });
  }

  CommentsByCount(type) {
    let count: number = 0;
    if (this.comments?.length >= 0) {
      switch (type) {
        case 1:
          //internal comments
          this.internalComments = this.comments.filter(x => x.isInternalComments == 1);
          count = this.internalComments?.length;
          break;
        case 2:
          //mechanic comments
          this.mechanicComments = this.comments.filter(x => !x.isCustomerComment && x.isInternalComments == 0);
          count = this.mechanicComments?.length;
          break;  
        case 3:
          //customer comments
          this.customerComments = this.comments.filter(x => x.isCustomerComment && x.isInternalComments == 0 && x.comment);
          count = this.customerComments?.length;
          break;
      }
    }
    return count;
  }

  ViewComment(viewContent, commentType) {
    this.commentType = commentType
    this.CommentsByCount(this.commentType);
    this.modalService.open(viewContent, { ariaLabelledBy: 'modal-basic-title', size: 'lg' }).result.then((result) => {
      this.closeResult = `Closed with: ${result}`;
    }, (reason) => {
      this.closeResult = `Dismissed ${this.getDismissReason(reason)}`;
    });
  }

  AddInternalComment() {
    let model = {
      AppointmentId: this.editAppointmentService.appointmentDetails.id,
      Comments: this.internalCommentData
    }
    this.service.addInternalComment(model).then((res) => {
      document.getElementById("modelButton").click();
      if (res?.responseObject) {
        this.getComments(this.editAppointmentService.appointmentDetails.id)
      }
      else if(res?.responseObject == 0)
      {
        let appointmentArchive = this.translate.instant("lblAppointmentDeleted");
        this.toastr.error(appointmentArchive);
      }
    })
  }

  EditComment(editcontent, comment) {
    this.Addedcomments = comment.comment;
    this.commentId = comment.id;
    this.closeModel = this.modalService.open(editcontent, { ariaLabelledBy: 'modal-basic-title', size: 'lg' })
    this.closeModel.result.then((result) => {
      this.closeResult = `Closed with: ${result}`;
    }, (reason) => {
      this.closeResult = `Dismissed ${this.getDismissReason(reason)}`;
    });
  }
  
  EditCommentDetails(comment:any,commentId:any) {
    let editModel = {
      appointmentId: this.editAppointmentService.appointmentDetails.id,
      comments: comment,
      commentId:commentId,
      userId: ""
    }
    this.service.EditInternalComment(editModel).then((res) => {
      if (res) {
        let successMsg = this.translate.instant("lblCommentEdited");
        this.toastr.success(successMsg);
        this.getComments(this.editAppointmentService.appointmentDetails.id);
      }
      else {
        let errorMsg = this.translate.instant("lblCommentNotEdited");
        this.toastr.error(errorMsg);
      }
    })
  }

  DeleteComment(Comments: any) {
    let modelHeadermsg = this.translate.instant("lblDelete");
    let modelBodymsg = Utility.createMessage(this.translate.instant("lblSureToDelete"), this.translate.instant("lblComment"), false);
    const modalRef = this.modalService.open(NgbdModalContent);
    modalRef.componentInstance.modelHeader = modelHeadermsg;
    modalRef.componentInstance.modelBody = modelBodymsg;
    modalRef.result.then((_result) => {
      // This is intentional
    }, (reason) => {
      this.popupCloseResult = this.getDismissReason(reason);
      if (this.popupCloseResult) {
        let deleteModel = {
          appointmentId: Comments.id
        }
        this.service.DeleteInternalComment(deleteModel).then((res) => {
          if (res) {
            let successMsg = this.translate.instant("lblCommentDeleted");
            this.toastr.success(successMsg);
            this.getComments(this.editAppointmentService.appointmentDetails.id);
          }
          else {
            let errorMsg = this.translate.instant("lblCommentNotDeleted");
            this.toastr.error(errorMsg);
          }
        })
      }
    });
  }

  AppointmentDataMapper(appointment: any) {
    let single = Object();
    single = appointment;
    single.id = appointment.id;
    single.licensePlate = appointment.licensePlate;
    single.customerName = appointment.customerName;
    single.mobileNo = appointment.mobileNo;
    single.mobileCode = appointment.mobileCode;
    single.dealerName = appointment.dealerName;
    single.appointmentStatusColor = appointment.appointmentStatusColor;
    single.brand = appointment.brand;
    single.dealerId = appointment.dealerId;
    single.modelName = appointment.modelName;
    single.brandCode = appointment.brandCode;
    single.brandName = appointment.brandName;
    single.workOrderNo = appointment.workOrderNo;
    single.workOrderStatus = appointment.workOrderStatus;
    single.workOrderStatusId = appointment.workOrderStatusId;
    single.workOrderStatusColor = appointment.workOrderStatusColor;
    single.appointmentStatusId = appointment.appointmentStatusId;
    single.bookedDate = appointment.bookedDate;
    single.createdDate = appointment.createdDate;
    single.createdDateTime = appointment.createdDateTime ? new Date(appointment.createdDateTime + 'Z') : null;
    single.bookedDateTime = appointment.bookedDateTime;
    single.appointmentType = appointment.appointmentType;
    single.appointmentGuid = appointment.appointmentGuid;
    single.createdTime = appointment.createdTime;
    single.appointmentStatus = appointment.appointmentStatus;
    single.isBookingAllowed = appointment.isBookingAllowed;
    single.sourceCreation = appointment.sourceCreation;
    single.unitPrice = appointment.unitPrice;
    single.chassisNo = appointment.chassisNo;
    single.totalCount = appointment.totalCount;
    single.isRentalCarRequired = appointment.isRentalCarRequired;
    single.isCustomerWaiting = appointment.isCustomerWaiting;
    single.dmsSyncStatus = appointment.dmsSyncStatus
    single.dmsSyncDate = appointment.dmsSyncDate ? new Date(appointment.dmsSyncDate + 'Z') : null;
    single.documentPartStatus = appointment.documentPartStatus;
    single.isFromArchive = appointment.isFromArchive;
    single.remark = appointment.remark;
    single.appointmentId = appointment.appointmentId;
    single.startDate = appointment.startDate;
    single.endDate = appointment.endDate;
    single.needAttention = appointment.needAttention;
    single.documentPartStatusId = appointment.documentPartStatusId;
    single.appointmentKeyList = appointment.appointmentKeyList;
    single.IsServiceContractVehicle = appointment.IsServiceContractVehicle;
    single.customerGuid = appointment.customerGuid;
    single.isCheckInSelected = appointment.isCheckInSelected;
    single.reasonForDeletion = appointment.reasonForDeletion;
    single.reasonForCancellation = appointment.reasonForCancellation;
    single.isDeleted = appointment.isDeleted;
    single.information = appointment.information;
    single.invoiceReference = appointment.invoiceReference;
    single.transportSolution = appointment.transportSolution;
    single.discountCode = appointment.discountCode;
    single.serviceAdvisorId = appointment.serviceAdvisorId;
    single.isAuthorizedByServiceAdvisor = appointment.isAuthorizedByServiceAdvisor;
    return single;
  }

  async getServiceAdvisorDetails(dealerId: string) {
    await this.receptionBusinessService.getUserList(this.userRequestModel).then((response) => {
      if (response.responseCode == Constant.SuccessResponseCode) {
        this.serviceAdvisorList = response.responseObject.filter(x=>x.roleId == Enums.UserRoles.ServiceAdvisor && x.defaultDealerId == dealerId && x.isActive);
        
      }
    });
  }

}
